export default __webpack_public_path__ + "static/media/Grid3.7.bb2ba59b.jpg";